import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { CommonService } from '../common.service';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
loginurl:any;
loginuserdetail:any;
returnUrl:"/dashboard";
jwttoken:any;
invalidstatus:boolean=false;
submitted:any;
errorverifyemail:any;
invalid=false;
registerForm:FormGroup;
registerFormval:FormGroup;
  constructor(private router: Router, private commonService: CommonService,private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    localStorage.setItem('token','');
    localStorage.setItem('hide','');
    this.registerForm = this.formBuilder.group({
      password: ['', Validators.required],
      email: ['',Validators.compose([Validators.required,Validators.email,Validators.pattern(/^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/)])],
      // status: ['', Validators.required]
  });
  this.registerFormval = this.formBuilder.group({
      email1: ['', {validators: [Validators.compose([Validators.required,Validators.email,Validators.pattern(/^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/)])], updateOn: 'blur'}],
    // status: ['', Validators.required]
});
  }
  
  get f() { return this.registerForm.controls; }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
        return;
    }
 
    // display form values on success
   this.submituser()

}
keyDownFunction(event) {
  this.invalidstatus=false;
  if (event.keyCode === 13) {
    this.onSubmit()
    // rest of your code
  }
}
keyDownFunctionsend(event){
  if (event.keyCode === 13) {
    this.submitresetemail()
  }
}
  async submituser(){
    this.loginurl="/login"
    this.loginuserdetail = {
      'email':$("#email").val(),
      'password':$("#password").val()
  };
    (await this.commonService.postApi( this.loginurl,this.loginuserdetail)).subscribe(
      res => {
         console.log(res.data);
         sessionStorage.setItem('userrole',JSON.stringify(res.data));
     localStorage.setItem('token',res.token);
     if(res.status == 200){
       //console.log('hiii');
       this.router.navigate(['dashboard']);
     }
     if(res.status !== 200){
       this.invalidstatus=true;
     }
      });
      
    

  }
  removeverification(){
    this.invalid=false;
  }
  async submitresetemail(){
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerFormval.invalid) {
      console.log(this.registerFormval)
        return;
    }
    var resetapiurl="/send_email"; 
    var resetemail = {
      'email':$("#emailreset").val(),
  };
 
  (await this.commonService.postApi( resetapiurl,resetemail)).subscribe(
    res => {
       console.log(res.data);
       if(res.status==200){
        $("#pwdModal").modal("hide");
        Swal.fire("Email successfully sent","Verification email valid for 2 minutes");
       }else{
         this.invalid=true;
        this.errorverifyemail=res.message
       }
          });
  }

}
